import script from "./WarrantyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WarrantyForm.vue?vue&type=script&setup=true&lang=js"

import "./WarrantyForm.vue?vue&type=style&index=0&id=03e92e62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e92e62"]])

export default __exports__